import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LmoBannedDriver, LmoDriver, LmoDriverService } from '~services/lmo-driver.service';
import { UserService } from '~services/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'sa-reinstate-driver-dialog',
  templateUrl: './reinstate-driver-dialog.component.html',
  styleUrls: ['./reinstate-driver-dialog.component.scss'],
})
export class ReinstateDriverDialogComponent {
  public accountName$: Observable<string>;

  public reasonControl = new FormControl();

  public networkActive$$ = new BehaviorSubject<boolean>(false);

  constructor(
    private matDialogRef: MatDialogRef<ReinstateDriverDialogComponent>,
    private userService: UserService,
    private lmoDriverService: LmoDriverService,
    @Inject(MAT_DIALOG_DATA)
    public data: { driver: LmoDriver | LmoBannedDriver },
  ) {
    this.accountName$ = this.userService.userContract$.pipe(map((contract) => contract?.account?.name));

    console.log(data.driver);
  }

  public async reinstateDriver() {
    if (this.networkActive$$.value) {
      return;
    }
    try {
      this.networkActive$$.next(true);
      const success = await this.lmoDriverService.unbanDriver(this.data.driver.banId, this.reasonControl.value);

      if (success) {
        this.matDialogRef.close();
      }
    } finally {
      this.networkActive$$.next(false);
    }
  }

  public closeDialog() {
    this.matDialogRef.close();
  }
}
